const list = {
    or: 'หรือ',
    and: 'และ',
    separator: ',',
};
export default Object.freeze(list);
